import { render } from "./ShippingMethodBasicInfo.vue?vue&type=template&id=1e785da6&scoped=true&ts=true"
import script from "./ShippingMethodBasicInfo.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodBasicInfo.vue?vue&type=script&lang=ts"

import "./ShippingMethodBasicInfo.vue?vue&type=style&index=0&id=1e785da6&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e785da6"]])

export default __exports__